var _polyline, _line, _line2, _line3, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 64 64",
    id: "Layer_1",
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    points: "  30.6,19.5 23.1,15.8 14.1,19.1 3.8,55.8 18.9,46.6 32,52.4 45.1,46.6 60.2,55.8 52.9,29.6 ",
    stroke: "#2C3E50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#2C3E50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 32,
    x2: 32,
    y1: 23.3,
    y2: 48.8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#2C3E50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 43.7,
    x2: 44.8,
    y1: 36.3,
    y2: 43.8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#2C3E50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 22.8,
    x2: 19.3,
    y1: 20,
    y2: 43.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "  M46.1,31c3.1-2.8,8.5-8,8.5-15.8c0-5.9-4.8-10.7-10.7-10.7S33.3,9.3,33.3,15.2c0,10.3,10.7,17.5,10.7,17.5S45.4,31.6,46.1,31z",
    fill: "none",
    stroke: "#2C3E50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.1,
    cy: 15.2,
    fill: "none",
    r: 5.7,
    stroke: "#2C3E50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.40e72592f842ce6256af08ceb2f9b219.svg";
export { ForwardRef as ReactComponent };